import '@assets/styles/pages/site-lead-overview-KAE.scss';
import { ReactElement } from 'react';
import { SiteOverviewInfo, ProductRecommendedInfo } from '.';

export const SiteLeadOverviewKAE = (): ReactElement => {
	return (
		<section className="site-lead-overview-kae-section">
			<SiteOverviewInfo />

			<div className="container">
				<ProductRecommendedInfo />
			</div>
		</section>
	);
};
